import React from 'react'
import AppBar from '@mui/material/AppBar';

export default function Banner(props) {
    return (
        <div>
            <AppBar position="static" style={{background:'#ffffff', textAlign:'center',  display:'inline-block'}}>
                <img src="/magnet.png" style={{height: '55px', width:'55px', display:'inline-block', marginBottom:'-10px'}}></img>
                <h1 style={{color:'black', width:'90%', display:'inline-block', margin:'10px'}}>Polarize - Electric Vehicles Database</h1>
            </AppBar> 
        </div>
    )
}
